import * as CONSTANTS from './constants';

export const fetchFeatureFlagsRequest = () => ({
  type: CONSTANTS.FETCH_FEATURE_FLAGS_REQUEST,
});

export const fetchFeatureFlagsSuccess = (data) => ({
  type: CONSTANTS.FETCH_FEATURE_FLAGS_SUCCESS,
  data,
});

export const fetchFeatureFlagsFail = (error) => ({
  type: CONSTANTS.FETCH_FEATURE_FLAGS_FAIL,
  error,
});